seo:
  ogImageAlt: Logo Tale
  home:
    title: "Tale : projets en équipe avec des agents IA"
    description: Planifie tes projets, délègue des tâches aux agents IA et examine les
      résultats en équipe. Un espace open source avec sandboxes, contexte
      partagé et workflows.
  pricing:
    title: Combien coûte Tale ? — Community & Enterprise
    description:
      'Tale Enterprise : CHF 12 (EUR 14) par utilisateur/mois, deux mois
      offerts en annuel. Community est gratuite en auto-hébergement en open source.'
  contact:
    title: Contacter l’équipe Tale — ventes, support, démos
    description:
      "Parle à l’équipe Tale de la collaboration avec les agents IA : projets,
      déploiement, tarifs ou démonstration adaptée à ton équipe."
  about:
    title: Qui est derrière Tale ? — À propos de Ruler GmbH
    description: "Ruler GmbH, à Spiez en Suisse, construit Tale : un espace de projet
      open source où les équipes coordonnent des agents IA et examinent
      leur travail."
  requestDemo:
    title: Demander une démo Tale — visite guidée
    description:
      Apporte une tâche à résoudre en équipe. Vois comment Tale coordonne
      collègues et agents IA avec des tableaux de projet, des sandboxes et des
      validations.
  hardwarePricing:
    title: Combien coûte le hardware AI Tale ?
    description:
      'Hardware d’inférence silencieux, du nœud unique au rack : location,
      leasing ou achat. Sur site avec maintenance à distance, ou en centres de
      données sécurisés.'
  platform:
    title: Coordonner agents IA et projets | Tale
    description: Réunis collègues, agents IA, tâches et fichiers dans un même espace.
      Tale relie tableaux de tâches, sandboxes, connaissances et workflows
      réutilisables.
  platformAgents:
    title: Agents IA pour les tâches de projet | Tale
    description:
      Configure les consignes, les outils et le moteur de tes agents, comme
      Claude Code ou Codex. Attribue des tâches et examine les fichiers qu’ils
      produisent.
  platformChat:
    title: Chat IA, sources et tâches de projet | Tale
    description: Pose des questions, vérifie les sources, compare deux modèles dans Arena
      et transforme une conversation en tâche pour un agent IA dans Tale.
  platformAutomations:
    title: Workflows réutilisables avec des agents IA | Tale
    description:
      Transforme les tâches récurrentes en workflows avec agents, conditions,
      connecteurs et approbations. Lance-les à la demande, sur horaire ou par
      webhook.
  platformKnowledge:
    title: Connaissances partagées pour travailler avec l’IA | Tale
    description: Donne du contexte au travail de l’IA. Indexe documents, sites web et
      fiches de connaissances, retrouve les sources accessibles et vérifie les
      citations.
  platformGovernance:
    title: Gouvernance IA, approbations et limites d’usage | Tale
    description: Configure les approbations des connecteurs, consulte les actions
      enregistrées et définis les budgets et filtres du chat de ton équipe
      dans Tale.
  platformProjects:
    title: Tableaux de tâches pour équipes et agents IA | Tale
    description: Planifie le travail avec tes collègues et tes agents IA sur un tableau
      partagé. Garde tâches, fichiers, conversations et validations dans le
      même projet.
  changelog:
    title: Quoi de neuf dans Tale ? — Changelog
    description: Les notes de version de Tale, de la plus récente à la plus
      ancienne — fonctionnalités, correctifs et changements de rupture, publiés
      depuis GitHub Releases.
notFound:
  title: Cette page n’existe pas
  body:
    L’adresse est peut-être mal saisie, ou la page a déménagé. Le mieux est de
    repartir de l’accueil.
  backHome: Retour à l’accueil
nav:
  platform: Plateforme
  resources: Ressources
  pricing: Tarifs
  openMenu: Ouvrir le menu
  closeMenu: Fermer le menu
  homeAriaLabel: Accueil Tale
  skipToMain: Aller au contenu principal
  product:
    hub:
      label: Vue d’ensemble
      description: Comment collègues et agents travaillent ensemble sur les projets.
    agents:
      label: Agents
      description: Délègue des tâches aux agents avec leurs outils et leur moteur.
    chat:
      label: Chats
      description: Pose des questions, vérifie les sources et délègue des tâches.
    projects:
      label: Projets
      description: Planifie, attribue et examine le travail en équipe.
    automations:
      label: Automatisations
      description: Workflows réutilisables avec déclencheurs et approbations.
    knowledge:
      label: Connaissances
      description: Un contexte partagé pour ton équipe et tes agents.
    governance:
      label: Gouvernance
      description: Examine les actions et limite l’usage des modèles.
  resource:
    compare:
      label: Comparatifs
      description: Compare les espaces de travail, les workflows et les environnements des agents.
    useCases:
      label: Cas d’usage
      description: Des tâches concrètes pour ton équipe et tes agents IA.
    hardware:
      label: Matériel
      description: Matériel pour l’inférence IA locale.
    docs:
      label: Documentation
      description: Guides de configuration et référence du produit.
    changelog:
      label: Changelog
      description: Ce qui a été livré, du plus récent.
    about:
      label: À propos
      description: L’entreprise suisse derrière Tale.
  aboutUs: À propos
  contactUs: Nous contacter
  requestDemo: Demander une démo
  getStarted: Démarrer
legal:
  downloadPdf: Imprimer ou enregistrer en PDF
  downloadPdfAria: Imprimer ou enregistrer {title} en PDF
  notFound: Ce document n’est pas disponible.
  documentTabsAria: Sections du document
  tabs:
    data-processing-agreement: DPA
    technical-organizational-measures: MTO
footer:
  taleUi: Tale UI
  resources: Ressources
  legal: Mentions légales
  pricing: Tarifs
  hardwarePricing: Tarifs matériel
  contact: Contact
  serviceAgreement: Contrat de service
  hardwareAgreement: Contrat matériel
  privacyPolicy: Politique de confidentialité
  termsOfService: Conditions d’utilisation
  processingAgreement: Contrat de sous-traitance
  technicalOrganizationalMeasures: Mesures techniques & organisationnelles
  homeAriaLabel: Accueil Tale
  githubAriaLabel: GitHub
  llmsTxtLabel: llms.txt
  llmsFullTxtLabel: llms-full.txt
  platform: Plateforme
  company: Entreprise
  changelog: Changelog
  features: Fonctionnalités
address:
  country: Suisse
home:
  hero:
    title: Ton équipe et tes agents avancent ensemble.
    subtitle: "Planifie le travail, confie des tâches aux agents et examine leurs résultats. Ton équipe partage le besoin, les fichiers et la conversation."
    ctaPrimary: Demander une démo
    ctaSecondary: Auto-héberger Tale
    eyebrow: Espace de projet open source
    proof: Tâches partagées · Délégation aux agents · Sandboxes en parallèle ·
      Open source
  demos:
    hero:
      label:
        "Exemple illustré : une question sur les escalades du support reçoit
        une réponse avec deux sources citées et le modèle sélectionné."
      prompt: Résume les escalades support d’hier et rédige un point de situation.
      routedTitle: Modèle sélectionné
      routedDetail: Auto a choisi Claude Sonnet pour ce fil.
      reply1: Hier, 7 escalades ont été enregistrées — 5 résolues, 2 encore ouvertes.
      reply2:
        Les deux cas ouverts sont des livraisons de vélos cargo retardées dans
        l’UE.
      reply3:
        Les opérations confirment que les unités de remplacement partent cette
        semaine —
      reply4: les deux contacts peuvent donc compter sur une résolution d’ici vendredi.
      citation1: escalades-q3.pdf
      citation2: runbook-livraison-ue.pdf
      thought: Réflexion 1 s
      composerModel: Claude Sonnet
      inputPlaceholder: Pose ta question…
    connect:
      label:
        'Démo animée : la liste Agents montre Claude Code, Codex, Hermes, Agent
        Support et OpenClaw comme lignes installées avec des chips de modèle.'
      windowTitle: Agents
      searchPlaceholder: Rechercher des agents
      addLabel: Agents
      colName: Nom
      colModel: Modèle
      colStatus: Statut
      statusReady: Prêt
      agent1: Claude Code
      agent2: Codex
      agent3: Hermes
      agent4: Agent Support
      agent5: OpenClaw
      model1: Claude Opus
      model2: GPT-5.5
      model3: Claude Sonnet
      model4: Claude Sonnet
      model5: Claude Opus
    knowledge:
      label:
        'Démo animée : la table Documents de la base de connaissances indexe un
        PDF, un site, un catalogue produits et un runbook, puis affiche les
        badges d’indexation.'
      windowTitle: Connaissances
      searchPlaceholder: Rechercher des documents
      addLabel: Connaissances
      colName: Nom
      colType: Type
      colStatus: Statut
      typePdf: PDF
      typeWebsite: Site
      typeCatalog: Catalogue
      typeEntry: Entrée
      statusIndexing: Indexation…
      statusIndexed: Indexé
      source1: escalades-q3.pdf
      sourceType1: pdf
      source2: aide.nordwind.eu
      sourceType2: website
      source3: Catalogue produits
      sourceType3: catalog
      source4: runbook-livraison-ue.pdf
      sourceType4: pdf
    automation:
      label: 'Démo animée : un canvas de workflow exécute Déclencheur → LLM →
        Condition → Action, puis la table Exécutions enregistre le run.'
      windowTitle: Automatisations
      kindTrigger: Déclencheur
      kindLlm: LLM
      kindCondition: Condition
      kindAction: Action
      statusCompleted: Terminé
      statusAwaiting: En attente d’approbation
      statusRunning: En cours
      trigger: Nouvel email
      llm: Classifier l’intention
      condition: Remboursement ?
      branchYes: Oui
      action: Rédiger la réponse
      actionAlt: Router vers les ventes
      logTitle: Exécutions
      logColRun: Run
      logColStatus: Statut
      logColDuration: Durée
      run1: '#482'
      runTone1: done
      duration1: 3,2 s
      run2: '#483'
      runTone2: pending
      duration2: —
      run3: '#484'
      runTone3: running
      duration3: 1,1 s
    govern:
      label:
        "Exemple illustré : une écriture de connecteur attend une approbation
        dans une automatisation, puis la décision et le résultat sont
        consignés."
      approvalTitle: Envoyer 42 emails de remboursement aux contacts concernés ?
      requester: Triage inbox · Rédiger la réponse
      approve: Approuver
      reject: Rejeter
      approved: Approuvé
      auditTitle: Journal du run
      audit1: Approuvé par anna@nordwind.eu
      audit2: 42 emails mis en file via Gmail
      audit3: Décision consignée dans le journal d’audit
      budgetLabel: Budget mensuel
      budgetValue: CHF 412 / 1 000
    arena:
      label:
        'Démo animée : Chat Arena compare une même question sur deux modèles —
        Claude Sonnet et GPT-5.5 côte à côte.'
      prompt: Rédige une réponse contact pour la livraison UE retardée.
      modelA: Claude Sonnet
      modelB: GPT-5.5
      vs: vs
      replyA1:
        Excuse le retard et confirme que les unités de remplacement partent
        cette semaine.
      replyA2: Propose une résolution vendredi et un lien de suivi dès qu’Ops le publie.
      replyA3: Termine avec le lien vers la politique d’escalade à partager en interne.
      replyB1:
        Reconnais le retard, cite la politique d’escalade et engage vendredi
        comme échéance.
      replyB2: Ajoute une courte checklist que le contact peut transmettre en interne.
      replyB3: Propose un créneau de rappel si le lien de suivi manque jeudi.
    projects:
      label:
        'Démo animée : la liste Projets montre des espaces de travail avec agents
        et membres.'
      windowTitle: Projets
      searchPlaceholder: Rechercher des projets
      newProject: Nouveau projet
      colName: Nom
      colAgents: Agents
      colMembers: Membres
      project1: Support client
      project2: Ingénierie
      project3: Recherche commerciale
      project4: Ops & logistique
      agents1: 3 agents
      agents2: 5 agents
      agents3: 2 agents
      agents4: 4 agents
      members1: '8'
      members2: '14'
      members3: '5'
      members4: '11'
    tasks:
      windowTitle: "Tâches"
      colTodo: "À faire"
      colInProgress: "En cours"
      colInReview: "En revue"
      colDone: "Terminé"
      working: En cours
      label:
        "Démo animée : un tableau de projet partagé avec À faire, En cours, En revue et Terminé. Personnes et agents prennent des tâches ; un agent travaille sur une carte."
      id1: TEAM-14
      title1: Planifier le brief de campagne
      assignee1: Non assigné
      id2: TEAM-15
      title2: Examiner les retours clients
      assignee2: Mira
      id3: TEAM-12
      title3: Créer le portail client
      assignee3: Agent de développement
      id4: TEAM-11
      title4: Examiner le rapport de recherche
      assignee4: Mira
      id5: TEAM-9
      title5: Actualiser le guide de l’équipe
      assignee5: Agent de documentation
    sandbox:
      filesTab: Files
      liveTab: Live
      treeRoot: workspace
      liveHint: Vue navigateur live
      label: 'Démo animée : un agent crée une page web, montre son code HTML
        dans le volet Files, puis ouvre la page dans la vue Live du navigateur.'
      prompt:
        Crée une petite page de projet et ouvre-la dans le navigateur pour que
        je puisse la vérifier.
      agent: Claude Code
      model: Claude Opus
      reply: index.html et un aperçu local sont prêts. Vérifie le code dans Files
        et la page dans Live.
      file1: index.html
      file2: styles.css
      file3: tests/preview.spec.ts
      file4: README.md
      activeFile: index.html
      code1: "<main><h1>Northwind</h1><p>Portail client</p>"
      code2: "<section><h2>Consignes</h2><p>Périmètre et objectifs</p></section>"
      code3: "<section><h2>Fichiers</h2><p>Code source et tests</p></section>"
      code4: "<section><h2>Vérification</h2><p>Prêt pour les retours</p></section></main>"
      browserUrl: http://127.0.0.1:5173
      browserTitle: Aperçu du projet · localhost
      previewTitle: "Northwind"
      previewDescription: "Portail client"
      previewItem1: "Consignes"
      previewDetail1: "Périmètre et objectifs"
      previewItem2: "Fichiers"
      previewDetail2: "Code source et tests"
      previewItem3: "Vérification"
      previewDetail3: "Prêt pour les retours"
  tour:
    title: De la tâche partagée au résultat vérifié
    subtitle: Attribue le travail, donne aux agents le contexte nécessaire et garde
      ton équipe impliquée à chaque étape du projet.
    connect:
      eyebrow: Agents & connectors
      title: "Confie le travail à tes agents"
      description: "Donne aux agents leurs consignes et outils. Suis le travail dans des sandboxes persistantes, puis examine les fichiers livrés."
    pool:
      eyebrow: Connaissances
      title: "Donne le bon contexte au travail"
      description: "Relie fichiers de projet et connaissances partagées. Examine les sources utilisées par les agents."
    delegate:
      eyebrow: Automatisations
      title: "Réutilise les workflows utiles"
      description: "Relie étapes d’agents, conditions et actions. Examine chaque exécution."
    govern:
      eyebrow: Approbations & audit
      title: "Examine et approuve"
      description: "Examine les livrables, approuve les actions configurées et consulte le journal d’audit."
    arena:
      eyebrow: Chat Arena
      title: "Compare les réponses des modèles"
      description: "Pose la même question à deux modèles dans Arena. Choisis la réponse adaptée."
    projects:
      eyebrow: Projets
      title: |-
        Planifie le travail
        avec ton équipe
      description: Réunis collègues, tâches, fichiers et conversations dans un projet.
        Confie le travail à une personne ou à un agent et suis sa progression
        sur le tableau.
    explore: Explorer {module}
  tagline:
    eyebrow: Ton espace de travail, tes choix
    title: Ton infrastructure. Tes données. Tes règles.
    subtitle:
      Choisis où fonctionne ton espace de travail et quels modèles utilisent
      tes agents.
    pillars:
      selfHosted:
        title: Auto-hébergé par défaut
        description:
          Installe Tale sur ton infrastructure ou choisis un hébergement géré.
          Les modèles locaux exécutent l’inférence sur place ; les
          fournisseurs, connecteurs et outils externes suivent les connexions
          configurées.
      security:
        title: Sécurité intégrée
        description:
          Gère membres, rôles, authentification unique, budgets et règles de
          protection dans le même produit. Consulte les journaux d’audit et
          l’historique des exécutions pour comprendre ce qui s’est passé.
      openSource:
        title: Entièrement open source
        description:
          Tout le code est public et open source. Lis-le, audite-le,
          change ce qu’il te faut — sans demander à personne.
  connectors:
    title: Branché sur les outils que tu utilises déjà
    subtitle:
      Connecte les services dont tes projets dépendent. Configure les
      identifiants, puis accorde aux agents et aux workflows les accès
      nécessaires à leur travail.
  agents:
    title: Tes agents, à ta façon
    subtitle: Utilise ton moteur préféré avec ton propre abonnement ou des modèles facturés par API.
  faq:
    eyebrow: FAQ
    title: Questions fréquentes
    stillQuestions: Encore des questions ?
    contactTeam: Contacter l’équipe
    whatIsTale:
      q: Qu’est-ce que Tale ?
      a: Tale est un espace de projet open source pour les équipes et les
        agents IA. Planifie les tâches avec tes collègues, délègue le travail
        aux agents et examine les résultats au même endroit. Tale réunit
        tableaux de tâches, sandboxes, connaissances et workflows. Tu peux
        aussi l’auto-héberger et utiliser des modèles privés.
    openSource:
      q: Tale est-il open source ?
      a: Oui. Tale est open source et toutes les fonctionnalités sont dans
        l’édition Community gratuite — Enterprise ajoute du support et des
        services, pas des fonctionnalités.
    onPrem:
      q: Tale peut-il tourner entièrement on-premises ou en environnement isolé ?
      a:
        Tale peut fonctionner sur ton infrastructure avec des modèles locaux.
        Un déploiement hors ligne demande aussi des dépendances locales et des
        connexions sortantes restreintes. Les modèles cloud, outils et
        connecteurs externes peuvent transmettre des données hors de ton
        réseau lorsqu’ils sont activés.
    enterprisePricing:
      q: Comment fonctionne la tarification Enterprise ?
      a:
        Enterprise est facturé par utilisateur et par mois, avec deux mois offerts en
        paiement annuel. Le stockage au-delà du quota inclus est facturé par
        To/mois. L’édition Community reste gratuite pour un usage auto-hébergé.

    byoModels:
      q: Dois-je apporter mes propres modèles d’IA ?
      a:
        Non. Tu peux apporter tes propres modèles, sans obligation. Tale prend en
        charge la plupart des grands fournisseurs d’IA sans majoration — l’usage
        cloud est facturé aux tarifs de ton fournisseur et n’est pas inclus dans
        les plans.




    whoFor:
      q: À qui s’adresse Tale ?
      a: "Tale s’adresse aux équipes qui veulent organiser le travail des agents
        IA et collaborer avec eux. Les profils techniques configurent les
        agents, les outils et les accès aux dépôts ; les autres membres
        décrivent les tâches, discutent de l’avancement et examinent les
        résultats. Projets logiciels, campagnes marketing, recherches,
        rapports ou opérations récurrentes : les possibilités dépendent des
        outils et des autorisations de chaque agent."
    agentSubscriptions:
      q: Puis-je utiliser mon abonnement à un agent ?
      a: Oui, si le moteur prend en charge cet abonnement. Ajoute ton propre
        jeton ou les identifiants de connexion compatibles, puis choisis le
        moteur correspondant. Tu peux aussi utiliser des modèles par API. Les
        appels via abonnement suivent les limites du fournisseur et passent en
        dehors du suivi et des plafonds de dépenses de la passerelle Tale ;
        vérifie cet usage auprès du fournisseur.
  cta:
    title: Lance ton prochain projet avec Tale
    description: Crée un espace auto-hébergé ou apporte une vraie tâche à une démo. Vois
      comment ton équipe et les agents IA peuvent la traiter ensemble.
    primary: Demander une démo
    getStarted: Démarrer
    terminalTitle: Auto-héberge en quatre commandes
    copy: Copier
    copied: Copié
    docsLink: Guide d'installation complet
complianceTrust:
  certifications:
    iso27001: Ruler GmbH · ISO 27001
    mit: Open source
    openSource: Open source
pricing:
  title: Combien coûte Tale ?
  description: Tale Enterprise coûte CHF 12 (EUR 14) par utilisateur/mois, avec
    deux mois offerts en facturation annuelle. L’édition Community open source est
    gratuite en auto-hébergement.
  note: Toutes les fonctionnalités sont incluses dans Community et Enterprise.
    L’usage supplémentaire de modèles IA cloud est facturé aux tarifs de ton
    fournisseur.
  popular: Populaire
  planIncludes: 'Le plan inclut :'
  billing:
    ariaLabel: Période de facturation
    monthly: Mensuel
    yearly: Annuel (2 mois offerts)
  billingNote:
    monthly: Facturé mensuellement
    yearly: Facturé annuellement · 2 mois offerts
  users:
    label: Nombre d’utilisateurs
    minTooltip: Minimum de 25 utilisateurs
  region:
    ariaLabel: Devise
    CH: CHF
    DE: EUR
  community:
    deployment: Auto-hébergé uniquement
    price: Gratuit
    priceSuffix: ''
    tagline: Chaque fonctionnalité du produit, gratuite en auto-hébergement — le
      support passe par GitHub.
    cta: Démarrer
    feature1: Auto-hébergé
    feature2: Open source
    feature3: Maintenu par la communauté (GitHub)
    feature4: Support communautaire (GitHub)
  enterprise:
    deployment: Cloud ou auto-hébergé
    priceSuffix: /mois + TVA
    storageAddOn: 1 To + {price}/To/mois de stockage supplémentaire
    userBreakdown: '{count} utilisateurs × {perUser}/utilisateur/mois'
    tagline:
      Tout Community, exploité par des pros — installation, maintenance et
      support, dans le cloud ou sur ton matériel.
    cta: Nous contacter
    feature1: Auto-hébergé ou cloud
    feature2: Exploitation professionnelle par Ruler GmbH, certifiée ISO 27001
    feature3: Accord de traitement des données (DPA)
    feature4: Support email, téléphone et à distance
    feature5: Installation et maintenance continue
    feature7: Influence sur la feuille de route
  compare:
    title: Comparer les plans
    subtitle: Détail de chaque plan
    categories:
      deployment: Déploiement
      compliance: Conformité
      support: Support
      installation: Installation standard
      maintenance: Maintenance
      customDevelopment: Développement sur mesure
      consulting: Conseil
      roadmap: Influence sur la feuille de route
    values:
      installationFee:
        CH: CHF 1 990
        DE: EUR 2 290
      hourlyRate:
        CH: CHF 180 / h
        DE: EUR 200–260 / h
    sections:
      services: Services professionnels
      other: Autres
    rows:
      selfHosted: Auto-hébergé
      cloud: Cloud
      localDataCenters: Centres de données locaux (CH & UE)
      dpa: Accord de traitement des données (DPA)
      iso: Exploitation certifiée ISO 27001
      piiRedaction: Masquage des données personnelles
      customDpa: DPA personnalisé
      customDpaInfo:
        Nous acceptons également des accords de traitement des données
        personnalisés avec nos clients.
      emailSupport: Support par email
      emailSupportInfo:
        'Réponses durant les heures ouvrables : lun.–ven., 08h00–17h00
        (CET/CEST).'
      phoneSupport: Support téléphone
      phoneSupportInfo: 'Disponible durant les heures ouvrables : lun.–ven.,
        08h00–17h00 (CET/CEST).'
      remoteSupport: Support à distance
      remoteSupportInfo: 'Disponible durant les heures ouvrables : lun.–ven.,
        08h00–17h00 (CET/CEST).'
    cellLabels:
      yes: Inclus
      no: Non inclus
  extras:
    hardware:
      title: Matériel
      prefix: Pour l’auto-hébergement, nous proposons des
      linkLabel: options matérielles flexibles
      suffix: ' — location, achat ou financement.'
    cloudProviders:
      title: Fournisseurs d’IA cloud
      description:
        Nous prenons en charge OpenAI, Anthropic, Gemini et d’autres grands
        fournisseurs d’IA cloud en CH & UE — sans marge ; l’usage est facturé
        aux tarifs du fournisseur.
  terms:
    title: Conditions
    prefix: Toutes les configurations sont soumises à notre
    linkLabel: contrat de service
    suffix: .
hardwarePricing:
  title: Combien coûte le hardware AI Tale ?
  description:
    Hardware d’inférence silencieux, du nœud unique au rack — location,
    leasing ou achat. Déployé sur site avec maintenance à distance, ou hébergé
    en centres de données sécurisés.
  popular: Populaire
  configIncludes: 'La configuration inclut :'
  billing:
    ariaLabel: Option de paiement
    leasing: Leasing
    buying: Achat
    termAriaLabel: Durée du leasing
    termHeading: 'Mois :'
  modesAriaLabel: Mode de déploiement
  deploymentNote: Toutes les configurations matérielles sont silencieuses (sans
    bruit) et peuvent être déployées chez toi et maintenues à distance par notre
    équipe, ou hébergées dans nos centres de données sécurisés.
  tiers:
    quality:
      priceSuffix: + TVA/mois
      buySuffix: + TVA
      tagline: Réglé pour la précision et des résultats constants.
      nodeTagline: Conçu pour la précision et des résultats constants.
      cta: Nous contacter
      highlightQuality: Qualité
      highlightSpeed: Standard
    hybrid:
      priceSuffix: + TVA/mois
      buySuffix: + TVA
      tagline: Équilibre précision et vitesse.
      nodeTagline: Associe le contrôle local des données à une inférence rapide.
      cta: Nous contacter
      highlightQuality: Élevée
      highlightSpeed: Élevée
    speed:
      priceSuffix: + TVA/mois
      buySuffix: + TVA
      tagline: Réglé pour des réponses à faible latence.
      nodeTagline: Conçu pour des réponses à faible latence.
      cta: Nous contacter
      highlightQuality: Standard
      highlightSpeed: Qualité
    rack:
      priceSuffix: + TVA/mois
      buySuffix: + TVA
      tagline: Performance multi-nœud dans un châssis unique et sécurisé — avec
        confidential computing.
      nodeTagline:
        Performance multi-nœud dans un châssis unique et sécurisé — avec
        confidential computing.
      cta: Nous contacter
      highlightQuality: Élevée
      highlightSpeed: Élevée
  compare:
    title: Comparer les configurations
    subtitle: Détail de chaque configuration
    categories:
      model: Modèle d’IA recommandé
      modelInfo:
        Suggestion pour une configuration multi-nœud. Les configurations à un
        seul nœud peuvent exécuter des variantes plus petites — ton équipe
        choisit le modèle réel au déploiement.
      size: Taille
      sizeInfo: Valeurs indicatives — les dimensions réelles peuvent varier légèrement.
      gpu: Puce (GPU)
      cpu: Puce (CPU)
      ram: RAM IA
      ramInfo:
        Mémoire rapide utilisée pour les calculs d’IA, p. ex. mémoire vidéo
        GDDR7 ou mémoire unifiée (UMA).
      umaInfo:
        Unified Memory Architecture — mémoire partagée entre le CPU et le GPU
        sur la même puce (Apple Silicon).
      gddr7Info:
        Graphics DDR de 7e génération — mémoire vidéo à haute bande passante
        sur la carte GPU, optimisée pour l’inférence d’IA.
      ddr5Info: DDR SDRAM de cinquième génération (plus rapide et efficace que DDR4).
      ddr5eccInfo:
        DDR5 avec code correcteur d’erreurs — mémoire serveur capable de
        détecter et corriger les défauts d’un seul bit.
      zen4Info: Microarchitecture x86 d’AMD de 4e génération (2022).
      zen5Info: Microarchitecture x86 d’AMD de 5e génération (2024).
      int4Info:
        Quantification entière 4 bits — perte de précision minime, empreinte
        mémoire ~4× plus petite.
      m2nvmeInfo: SSD m.2 NVMe dans un pool ZFS RAID — stockage rapide et redondant.
      nqInfo: Nœud Quality
      naInfo: Nœud Application
      nsInfo: Nœud Speed
      mqInfo: Multi-nœud Quality
      mhInfo: Multi-nœud Hybrid
      msInfo: Multi-nœud Speed
      srInfo: Server Rack
      systemRam: RAM
      ssd: SSD
      hdd: HDD
      cables: Câbles & équipement réseau
      confidentialComputing: Confidential computing
      version: Version du produit
      productNumber: Numéro de produit
      composition: Composition
    cellLabels:
      yes: Inclus
      onRequest: Disponible sur demande
      notAvailable: Non disponible
    sections:
      specifications: Spécifications
      other: Autres
  extras:
    software:
      title: Logiciels & services
      prefix:
        Pour l’installation, le support et les services professionnels, nous
        proposons des
      linkLabel: options flexibles
      suffix: .
  terms:
    title: Conditions
    prefix: Toutes les configurations sont soumises à notre
    linkLabel: contrat matériel
    suffix: .
  warranty:
    title: Garantie
    content: Garantie constructeur 24 mois (extensible à 36 mois sur demande)
  metrics:
    quality: Qualité de sortie
    speed: Vitesse en tokens
    storage: Stockage de données
requestDemo:
  eyebrow: Démo
  title: Regarde Tale en action
  paragraph1: 'Une démo guidée, c’est le produit en direct, pas des slides : des
    agents connectés, des réponses ancrées dans ton type de connaissances, une
    automation qui attend son approbation — sur une instance auto-hébergée.'
  paragraph2: Dis-nous ce que ton équipe utilise aujourd’hui et ce qui ne doit
    jamais quitter ton réseau. On te répond sous un jour ouvré, avec un créneau
    et un plan qui tient la route.
  fieldName: Nom
  fieldPhone: Téléphone
  fieldCompany: Entreprise
  fieldInterests: Intéressé par
  fieldMessage: Commentaire complémentaire
  placeholderName: Saisis ton nom complet
  placeholderEmail: Saisis ton adresse email
  placeholderPhone: Saisis ton numéro de téléphone
  placeholderCompany: Saisis le nom de ton entreprise
  placeholderMessage: Décris ton projet. Tous les détails partagés restent confidentiels.
  interests:
    enterprise: Solutions Entreprise
    professionalServices: Services professionnels
    customAiTraining: Entraînement de modèle IA sur mesure
    aiHardware: Matériel IA
  submit: Prendre contact
contact:
  eyebrow: Contact
  title: Nous contacter
  description:
    Présente un projet que ton équipe veut confier à des agents IA, ou pose
    tes questions sur le déploiement, Enterprise et le support. Explique
    comment ton équipe travaille aujourd’hui.
  fieldName: Nom
  fieldCompany: Entreprise
  fieldMessage: Message
  placeholderName: Saisis ton nom complet
  placeholderEmail: Saisis ton adresse email
  placeholderCompany: Saisis le nom de ton entreprise
  placeholderMessage:
    Partage quelques détails pour que nous comprenions mieux tes
    besoins. Tous les détails partagés restent confidentiels.
  submit: Prendre contact
forms:
  email: Courriel
  honeypotLabel: Site web
  privacyPrefix: Je confirme avoir lu la
  privacyLink: politique de confidentialité
  privacyRequired: Confirme que tu as lu la politique de confidentialité.
  validation:
    nameRequired: Saisis ton nom.
    nameTooLong: Ton nom doit contenir au maximum 2 000 caractères.
    emailRequired: Saisis ton adresse e-mail.
    emailInvalid: Saisis une adresse e-mail valide.
    emailTooLong: L’adresse e-mail doit contenir au maximum 2 000 caractères.
    companyTooLong: Le nom de l’entreprise doit contenir au maximum 2 000 caractères.
    messageRequired: Saisis ton message.
    messageTooShort: Donne-nous un peu plus de détails. Utilise au moins 10 caractères.
    messageTooLong: Ton message doit contenir au maximum 2 000 caractères.
    phoneInvalid: Utilise des chiffres, des espaces, +, - ou des parenthèses pour le numéro.
    phoneTooShort: Saisis un numéro de téléphone avec au moins 4 chiffres.
    phoneTooLong: Le numéro de téléphone doit contenir au maximum 32 caractères.
    invalid: Vérifie cette valeur et réessaie.
  errors:
    generic: Quelque chose s’est mal passé. Réessaie.
    rateLimited: Trop d’envois. Patiente un instant et réessaie.
    notConfigured: Cette installation n’a pas encore configuré l’envoi de
      formulaires — ton message n’a pas été envoyé. Contacte l’équipe par un
      autre canal.
    serverUnavailable: Nous n’avons pas pu envoyer ton message pour le moment.
      Réessaie dans quelques minutes.
    tooFast: Un instant — vérifie tes informations avant d’envoyer.
  success:
    title: Merci — bien reçu
    description: Nous revenons vers toi sous un jour ouvré.
    sendAnother: Envoyer un autre message
about:
  hero:
    eyebrow: À propos
    title: Qui est derrière Tale ?
    description: Ruler GmbH, à Spiez en Suisse, développe Tale. Nous construisons un
      espace de projet open source où les personnes et les agents IA résolvent
      des problèmes ensemble. Notre certification ISO 27001 couvre Tale
      Enterprise et les services professionnels.
    ctaContact: Nous contacter
    ctaGithub: Voir le code
  facts:
    founded:
      label: Fondée
      value: '2020'
    location:
      label: Siège
      value: Spiez, Suisse
    certified:
      label: Certifiée
      value: Ruler GmbH · ISO 27001
    license:
      label: Licence
      value: Entièrement open source
  story:
    heading: Notre histoire
    p1: Ruler GmbH a été fondée en 2020 à Spiez, dans le canton de Berne, par
      Yannick Monney. Depuis le premier jour, l’entreprise est basée en Suisse
      et neutre vis-à-vis des fournisseurs — sans lien avec un fournisseur de
      cloud ou de modèles.
    p2: Nous construisons Tale pour les entreprises qui veulent faire travailler
      des agents IA avec leurs équipes. Le travail demande des responsables,
      du contexte, de la coordination et un endroit où examiner les résultats.
      Un espace de projet partagé réunit ces éléments.
    tagline: Ton infrastructure. Tes données. Tes règles.
    p3: Tale réunit tableaux de projet, sandboxes, fichiers, connaissances et
      workflows dans un produit. Les équipes attribuent des tâches, suivent
      les agents et examinent les livrables ensemble, en choisissant leurs
      moteurs, modèles et mode de déploiement.
  product:
    heading: Ce que nous construisons
    description: "Tale est un espace open source pour les équipes et les agents IA : un
      même endroit pour planifier les projets, déléguer les tâches et examiner
      les résultats."
    orchestrator:
      title: Collègues et agents sur le même projet
      body: Confie le travail à tes collègues ou à des agents de projet. Donne aux
        agents des consignes, des outils et un moteur pris en charge, puis
        suis leurs tâches et examine leurs productions.
    openSource:
      title: Open source, sans astérisque
      body: Tout le code est public et open source sur GitHub. La version
        Community gratuite embarque les mêmes fonctionnalités ; Enterprise
        ajoute support et services pour CHF 12 (EUR 14) par utilisateur/mois.
    deployment:
      title: Ton infrastructure ou la nôtre
      body: Auto-héberge Tale sur ton infrastructure ou choisis un hébergement
        géré en Suisse ou dans l’UE. Choisis des modèles locaux ou cloud et
        configure les services externes accessibles à l’espace de travail.
    beyond:
      title: Au-delà du logiciel
      body: Nous fournissons du matériel IA à louer, financer ou acheter pour les équipes qui exécutent des modèles sur leur propre infrastructure.
  work:
    heading: Comment nous travaillons avec les entreprises
    description: Faire travailler des agents demande un processus clair et un logiciel
      adapté. Nous aidons les équipes à préparer leurs sources, définir des
      tâches utiles et organiser la revue des résultats.
    dataQuality:
      title: Des données dignes de tes agents
      body: Nous aidons à structurer les sources, les responsabilités et la
        provenance pour que les personnes et les agents puissent trouver et
        vérifier les éléments utiles.
    regulated:
      title: À l’aise dans les environnements régulés
      body: Nous aidons les équipes à évaluer leurs besoins de déploiement,
        d’accès et de validation. La certification ISO 27001 de Ruler GmbH
        couvre Tale Enterprise et les services professionnels ; demande le
        périmètre et les justificatifs adaptés à ton organisation.
    edge:
      title: Une avance qui te reste
      body: Conserve le contexte des projets, les workflows et l’historique des
        validations à mesure que tu ajoutes des agents. Le code open source et le choix
        des moteurs et du déploiement permettent d’adapter Tale au fonctionnement
        de ton entreprise.
    tailored:
      title: Des solutions taillées sur tes objectifs
      body: Aucune organisation n’adopte l’IA de la même façon. Nous construisons
        les agents, les automatisations, les connaissances et le matériel autour
        de ce que tu veux atteindre — et laissons de côté le reste.
  values:
    heading: Ce que nous défendons
    privacy:
      title: Tes données restent les tiennes
      body: Garde la main sur le déploiement et les modèles. Utilise l’inférence
        locale si nécessaire et vérifie les flux de données des services
        externes que tu connectes.
    neutrality:
      title: Indépendant et neutre
      body: Basé en Suisse et neutre vis-à-vis des fournisseurs — sans lien
        avec un fournisseur de cloud ou de modèles, pour que ton déploiement ne
        réponde qu’à toi.
    transparency:
      title: Transparent par défaut
      body: Une base de code publique et open source, ainsi qu’une entreprise que tu
        peux vérifier au registre du commerce suisse. Ce que nous livrons, tu
        peux le lire.
    control:
      title: L’humain garde la main
      body: Les personnes définissent le travail, accordent les accès aux agents
        et configurent les règles de validation et d’approbation. L’équipe
        examine les livrables et l’historique avant de décider de la suite.
  cta:
    title: Parle à l’équipe
    description: Des questions sur Tale, le déploiement ou une collaboration
      avec Ruler GmbH ? Réserve une démo ou écris-nous via le formulaire de
      contact.
featureShared:
  ctaPrimary: Demander une démo
  ctaSecondary: Nous contacter
  ctaGetStarted: Démarrer
  ctaTitle: Vois le prochain workflow de ton équipe dans Tale
  ctaDescription: Apporte une tâche à une démo guidée ou crée un espace et essaie avec tes
    propres agents.
  relatedHeading: Modules associés
  docsHeading: Lire la doc
platformAgents:
  eyebrow: Agents
  title: Que sont les agents dans Tale ?
  description: Les agents de projet travaillent sur les tâches avec ton équipe. Donne à
    chacun des consignes, un moteur pris en charge, un modèle et des outils,
    puis suis son travail dans la sandbox et examine ses rapports et fichiers.
  capabilities:
    heading: Que peuvent faire les agents ?
    description:
      Configure des agents réutilisables pour les tâches du projet, de la
      recherche et la préparation de documents aux modifications de code et à
      leur examen.
    items:
      - title: Un rôle et un moteur définis
        body:
          Choisis un moteur, un modèle et un fournisseur compatibles, des
          consignes permanentes et l’équipement nécessaire au travail.
        docsLabel: Concepts agents
      - title: Environnements d'agent pris en charge
        body:
          Lie Claude Code, Codex, Hermes et OpenClaw comme environnement d'agent sur lequel
          tourne un agent de projet ou un nœud agent d’automation.
        docsLabel: Environnements d'agent
      - title: Délégation entre agents
        body:
          Un agent de coordination équipé pour cela peut lancer d’autres
          agents sur les tâches prêtes du même projet, dans les limites de
          délégation, d’accès et de capacité.
        docsLabel: Automatisation des tâches
      - title: Skills comme bundles réutilisables
        body:
          Fournis aux agents des consignes réutilisables et des fichiers
          d’appui sous forme de skills, par exemple pour préparer des
          documents ou examiner des modifications.
        docsLabel: Agents de projet
      - title: Des outils pour le contexte du projet
        body:
          Accorde les outils de la plateforme dont l’agent a besoin pour
          trouver des tâches, lire des fichiers et consulter les
          connaissances. Les règles d’accès aux sources restent applicables.
        docsLabel: Base de connaissances
  faq:
    heading: FAQ agents
    items:
      - q: Qu’est-ce qu’un agent dans Tale ?
        a:
          Un agent de projet est un exécutant réutilisable dans un projet. Son
          moteur, son modèle, ses consignes et ses outils définissent sa façon
          de traiter les tâches. Ses rapports et fichiers restent associés à
          la tâche pour examen.
      - q: Peut-on utiliser nos propres abonnements ou clés API ?
        a:
          Oui. Connecte tes accès API, ou utilise un abonnement Anthropic
          compatible avec Claude Code ou un abonnement ChatGPT avec Codex pour
          les agents de tâches et d’automatisations. Un administrateur
          configure les accès ou le broker de jetons. Le chat nécessite des
          accès API ; la disponibilité et les limites des abonnements
          dépendent du fournisseur et de l’offre.
      - q: Quand utiliser un agent plutôt qu’un workflow ?
        a:
          Utilise un agent de projet pour un résultat qui demande des outils,
          des fichiers ou plusieurs étapes de travail. Choisis une
          automatisation pour définir des étapes, conditions ou déclencheurs
          réutilisables.
      - q: Chaque agent peut-il utiliser un modèle différent ?
        a:
          Oui. Choisis un modèle et un fournisseur par agent de projet, selon
          la compatibilité du moteur et les modèles disponibles dans ton
          organisation. Les changements s’appliquent aux exécutions suivantes.
  docs:
    - label: Concepts agents
      path: /platform/agents/concepts
    - label: Agents de projet
      path: /platform/projects/project-agents
    - label: Environnements d'agent
      path: /platform/agents/harnesses
    - label: Automatisation des tâches
      path: /platform/projects/task-automation
    - label: Base de connaissances
      path: /platform/knowledge/overview
  tour:
    heading: Comment les agents apparaissent dans Tale
    description:
      Configure les agents d’un projet, fournis-leur les outils et le contexte
      utiles, puis suis leur travail à travers leurs rapports et livrables.
    stages:
      - id: projects
        eyebrow: Projets
        title: |-
          Isole les agents
          par équipe
        description:
          Chaque projet possède sa propre configuration d’agents. L’accès au
          projet détermine qui peut voir les agents et leurs tâches.
      - id: knowledge
        eyebrow: Connaissances
        title: |-
          Ancre chaque agent
          dans ce que tu sais
        description:
          Ajoute le brief et les fichiers de référence, puis accorde des
          outils pour consulter les connaissances accessibles. Indique
          clairement à l’agent quelles sources utiliser.
  demos:
    knowledge:
      label: "Exemple illustré : documents de référence qu’un agent peut utiliser
        avec les outils de recherche et les droits d’accès appropriés."
      source1: support-macros.pdf
      sourceType1: pdf
      source2: Voix de marque
      sourceType2: entry
      source3: agents.nordwind.eu
      sourceType3: website
      source4: returns-playbook.pdf
      sourceType4: pdf
    projects:
      label:
        'Démo animée : projets découpés pour que Support et Platform gardent
        chacun leur stack d’agents et leurs membres.'
      project1: Bureau support
      agents1: 4 agents
      members1: '9'
      project2: Build plateforme
      agents2: 6 agents
      members2: '12'
      project3: Docs & enablement
      agents3: 2 agents
      members3: '4'
      project4: Train de release
      agents4: 3 agents
      members4: '7'
platformAutomations:
  eyebrow: Automatisations
  title: Que sont les automatisations dans Tale ?
  description: Les automatisations rendent le travail récurrent réutilisable. Relie
    appels de modèles, étapes d’agents et actions dans un workflow versionné,
    teste-le et lance-le à la demande ou avec un déclencheur configuré.
  capabilities:
    heading: Définir et répéter le processus
    description: Garde les étapes, versions, déclencheurs et historiques ensemble pour
      que l’équipe puisse examiner comment le travail récurrent est réalisé.
    items:
      - title: Versions enregistrées et déploiement
        body:
          Enregistre une nouvelle version quand le workflow change. Déploie
          celle que les prochaines exécutions réelles utiliseront ; les
          exécutions en cours conservent leur version de départ.
        docsLabel: Concepts des automatisations
      - title: Étapes de workflow typées
        body:
          Combine appels de modèles, travail d’agents en sandbox,
          transformations de données, sous-automatisations et actions
          connectées. Ajoute des conditions ou des répétitions lorsque l’étape
          les prend en charge.
        docsLabel: Éditeur workflow
      - title: Déclencheurs adaptés au travail
        body:
          Plannings (cron), webhooks, événements plateforme ou un run de test manuel
          depuis l’éditeur.
        docsLabel: Déclencheurs
      - title: Journaux d’exécution
        body:
          Examine l’état, les entrées, les sorties et le détail des étapes
          d’une exécution. Consulte les effets consignés des Connectors pour
          vérifier ce qui s’est passé.
        docsLabel: Journaux d’exécution
      - title: Approbations dans la boucle
        body:
          Les règles des Connectors peuvent suspendre les écritures protégées
          jusqu’à leur approbation. Une étape d’agent peut aussi demander les
          informations manquantes à une personne avant de continuer.
        docsLabel: Concepts des automatisations
  faq:
    heading: FAQ automations
    items:
      - q: Qu’est-ce qu’une automation dans Tale ?
        a:
          Une automatisation définit un workflow réutilisable avec des
          entrées, des étapes et des sorties. Les versions, le déploiement,
          les déclencheurs et l’historique permettent à ton équipe de tester
          et d’exploiter ce processus.
      - q: Existe-t-il un produit workflow autonome ?
        a:
          Non. Un workflow vit dans son automation. L’onglet Éditeur de l’automation
          est là où tu rencontres le graphe.
      - q: Quand utiliser une automation plutôt qu’un agent ?
        a: Utilise une automatisation pour des étapes réutilisables, des
          conditions, des horaires ou des actions connectées. Confie à un
          agent de projet une tâche dont tu examineras le résultat. Une
          automatisation peut inclure le travail d’un agent.
      - q: Puis-je tester un workflow avant de le planifier ?
        a:
          Oui. Teste une version enregistrée avant de la déployer ou d’activer
          un déclencheur. Les tests simulent les opérations des Connectors.
          Les exécutions réelles peuvent modifier les systèmes connectés et
          demander une approbation.
  docs:
    - label: Concepts des automatisations
      path: /platform/automations/concepts
    - label: Éditeur workflow
      path: /platform/automations/editor
    - label: Déclencheurs
      path: /platform/automations/triggers
    - label: Journaux d’exécution
      path: /platform/automations/execution-logs
    - label: Automatisations intégrées
      path: /platform/automations/builtin
  tour:
    heading: Comment les automatisations tournent dans Tale
    description:
      Définis le processus, choisis les étapes et les données nécessaires,
      puis examine chaque exécution. Configure les règles d’approbation des
      écritures protégées des Connectors.
    stages:
      - id: govern
        eyebrow: Approbations
        title: |-
          Human-in-the-loop
          avant l’envoi
        description:
          Lorsqu’une règle exige une approbation, une écriture de Connector
          attend la décision d’une personne. L’approbation autorise la
          tentative d’exécution ; le refus l’empêche.
      - id: agents
        eyebrow: Agents
        title: |-
          Confie à un agent
          une étape du workflow
        description: Configure une étape d’agent avec son moteur, son modèle, ses
          consignes et son équipement. Utilise un appel de modèle lorsqu’une
          seule réponse suffit.
  demos:
    automation:
      label:
        'Démo animée : une pipeline de factures extrait les lignes, retient les
        montants au-dessus de CHF 5 000 pour approbation et enregistre le reste
        dans l’ERP ; la table Exécutions garde la trace de chaque run.'
      trigger: Facture reçue
      llm: Extraction
      condition: Gros montant ?
      branchYes: Oui
      action: Attendre accord
      actionAlt: Vers l’ERP
      run1: '#1207'
      runTone1: done
      duration1: 4,8 s
      run2: '#1208'
      runTone2: pending
      duration2: —
      run3: '#1209'
      runTone3: running
      duration3: 1,2 s
    govern:
      label: "Exemple illustré : un workflow de factures attend l’approbation d’une
        écriture de Connector dans le détail de son exécution. Le résultat est
        consigné après l’approbation."
      approvalTitle: Enregistrer 7 factures totalisant CHF 23 410 dans l’ERP ?
      requester: 'Pipeline factures · Run #1208'
      audit1: Approuvé par finance@nordwind.eu
      audit2: 7 factures enregistrées dans l’ERP
      audit3: 'Run #1208 terminé en 41 s'
      budgetValue: CHF 1 240 / 2 500
    connect:
      label:
        "Exemple illustré : agents pour les tâches de facturation,
        fournisseurs, ERP, rapprochement et exceptions. Les étapes d’agents
        des workflows ont leur propre configuration."
      agent1: Agent Facture
      model1: Claude Sonnet
      agent2: Agent Fournisseur
      model2: GPT-5.5
      agent3: Agent ERP
      model3: Claude Opus
      agent4: Agent Matching
      model4: Claude Sonnet
      agent5: Agent Exceptions
      model5: GPT-5.5
    projects:
      label:
        "Exemple illustré : des projets organisent les tâches et les agents
        associés à des workflows récurrents."
      project1: Ops factures
      agents1: 3 agents
      members1: '6'
      project2: Intake fournisseurs
      agents2: 2 agents
      members2: '4'
      project3: CI ingénierie
      agents3: 4 agents
      members3: '10'
      project4: Revues nocturnes
      agents4: 2 agents
      members4: '5'
platformChat:
  eyebrow: Chats
  title: Pose des questions, compare, puis confie le travail à un agent
  description: Utilise le chat pour comprendre un problème, consulter les sources du
    projet et préparer des consignes. Si le travail nécessite des fichiers, du
    code ou des outils, crée une tâche de projet et attribue-la à un agent.
  capabilities:
    heading: Que comprend Chat ?
    description: Examine une question, vérifie les sources et prépare la prochaine tâche.
    items:
      - title: Choisir un modèle
        body:
          Choisis un modèle et son fournisseur, ou laisse Auto sélectionner un
          modèle pour chaque message selon les règles de ton organisation.
        docsLabel: Les bases du chat
      - title: Vérifier les sources
        body:
          Ouvre les documents et pages utilisés dans une réponse. Vérifie que
          les sources étayent la conclusion.
        docsLabel: Les bases du chat
      - title: Comparer deux modèles dans Arena
        body:
          Envoie la même demande avec le même contexte initial à deux modèles.
          Lis les deux réponses et choisis comment poursuivre.
        docsLabel: Mode Arena
      - title: Joindre les fichiers utiles
        body:
          Ajoute des documents, images ou enregistrements pris en charge. Le
          traitement et les capacités du modèle déterminent ce que l’assistant
          peut lire.
        docsLabel: Pièces jointes
      - title: Passer d’une question à une tâche
        body:
          Crée une tâche de projet depuis la conversation lorsqu’un agent doit
          produire des fichiers ou travailler dans une sandbox.
        docsLabel: Agents de projet
  faq:
    heading: FAQ Chat
    items:
      - q: Qu’est-ce que le chat dans Tale ?
        a:
          Le chat utilise l’assistant intégré pour les questions, la recherche
          de sources et les brouillons de texte. Il peut consulter les
          connaissances accessibles de l’entreprise et le contexte du projet
          actuel.
      - q: Faut-il configurer un agent de projet pour discuter ?
        a:
          Non. Le chat utilise l’assistant intégré de Tale et le modèle
          choisi. Les agents de projet sont des exécutants distincts auxquels
          tu attribues des tâches.
      - q: Qu’est-ce que le mode Arena ?
        a:
          Arena envoie une demande à deux modèles avec le même contexte
          initial. Tu compares leurs réponses et donnes un avis avant de
          poursuivre la conversation.
      - q: Comment transformer une conversation en travail concret ?
        a: Crée une tâche de projet depuis la conversation et attribue-la à un
          agent. Le chat lui-même n’exécute pas de code, ne modifie pas les
          systèmes connectés et ne produit pas de fichiers livrables.
          L’avancement et les résultats de la tâche restent liés à la
          conversation.
  docs:
    - label: Vue d’ensemble Chat
      path: /platform/chat/overview
    - label: Bases du Chat
      path: /platform/chat/basics
    - label: Mode Arena
      path: /platform/chat/arena-mode
    - label: Agents de projet
      path: /platform/agents/concepts
    - label: Pièces jointes
      path: /platform/chat/attachments
  tour:
    heading: Comment Chat fonctionne dans Tale
    description:
      Examine le problème dans le chat, puis utilise les tâches de projet et
      les automatisations pour la suite du travail.
    stages:
      - id: projects
        eyebrow: Projets
        title: |-
          Garder les échanges
          avec le travail
        description:
          Utilise les chats du projet pour leur contexte commun et choisis les
          conversations à partager avec ses membres. Tâches, fichiers et
          instructions restent dans le même projet.
      - id: knowledge
        eyebrow: Connaissances
        title: |-
          Vérifier les réponses
          à partir des sources
        description:
          Le chat peut consulter les connaissances et fichiers de projet
          accessibles. Ouvre les sources d’une réponse et vérifie-les avant
          d’utiliser le résultat.
  demos:
    arena:
      label:
        "Illustration : deux modèles rédigent une annonce à partir des mêmes
        consignes de version dans Arena."
      prompt: Rédige une annonce à partir des consignes de version jointes.
      modelA: Claude Sonnet
      modelB: GPT-5.5
      replyA1: Commence par l’amélioration principale décrite dans les consignes.
      replyA2:
        Explique à qui elle est utile et cite la note de version
        correspondante.
      replyA3: Termine par la prochaine étape documentée.
      replyB1: Pars du problème client auquel répond cette version.
      replyB2: Énumère les changements et relie chacun à sa source.
      replyB3: Termine par les modalités de déploiement indiquées dans les consignes.
    projects:
      label:
        "Illustration : les projets rassemblent les chats, tâches, fichiers et
        agents liés au même travail."
      project1: Fils support
      agents1: 3 agents
      members1: '8'
      project2: Chat ingénierie
      agents2: 5 agents
      members2: '11'
      project3: Brouillons Comms
      agents3: 2 agents
      members3: '4'
      project4: Salle de pilotage
      agents4: 3 agents
      members4: '6'
    knowledge:
      label:
        'Démo animée : les sources que Chat récupère pour une réponse ancrée — le
        PDF des notes de version, le crawl du changelog, le modèle d’annonce et
        l’entrée de voix de marque.'
      source1: release-notes-2.4.pdf
      sourceType1: pdf
      source2: changelog.nordwind.eu
      sourceType2: website
      source3: Modèle d’annonce
      sourceType3: entry
      source4: Guide de ton
      sourceType4: entry
platformGovernance:
  eyebrow: Gouvernance
  title: Définis les règles de ton équipe et de tes agents
  description:
    Gère les accès, configure les approbations des connecteurs et consulte les
    actions enregistrées. Définis les budgets de modèles et les filtres du
    chat pour le travail de ton équipe et de ses agents.
  capabilities:
    heading: Que couvre la gouvernance ?
    description: Choisis les écritures des connecteurs à approuver, les outils autorisés
      aux agents et les règles de contenu et d’usage à appliquer.
    items:
      - title: Approuver les écritures des connecteurs
        body:
          Une écriture de connecteur dans une automatisation attend une
          approbation si ta politique l’exige. C’est le cas par défaut pour
          les écritures externes ; les lectures et écritures internes suivent
          d’autres règles.
        docsLabel: Comprendre les approbations
      - title: Examiner l’opération proposée
        body:
          Vérifie la destination et les entrées exactes avant d’approuver.
          Rejette une opération incorrecte, corrige le processus ou ses
          entrées, puis lance une nouvelle exécution.
        docsLabel: Comprendre les approbations
      - title: Consulter le journal d’audit
        body:
          Examine les actions et décisions d’approbation enregistrées avec
          leur auteur et leur date. Utilise le journal pour comprendre ce qui
          s’est passé.
        docsLabel: Journaux d’audit
      - title: Définir les règles de l’organisation
        body:
          Configure les instructions communes, les règles d’accès et les
          outils des agents. Les autorisations et filtres appliqués complètent
          les instructions données au modèle.
        docsLabel: Garde-fous
      - title: Configurer les filtres du chat
        body:
          Active les filtres de contenu, la détection de données personnelles
          et la modération facultative sur les entrées ou sorties du chat de
          ton choix. Teste les motifs et le comportement en cas d’erreur.
        docsLabel: Garde-fous
      - title: Définir des budgets pour l’usage mesuré
        body:
          Suis l’usage de modèles enregistré et définis des budgets sur les
          parcours pris en charge, dont les exécutions gérées d’agents. Les
          appels directs par abonnement dépendent des contrôles du
          fournisseur.
        docsLabel: Analyse de l’utilisation
  faq:
    heading: FAQ gouvernance
    items:
      - q: Que contrôle la gouvernance ?
        a: La gouvernance regroupe les règles d’accès, les approbations des
          connecteurs, les événements d’audit, les budgets d’usage et les
          filtres du chat. Chaque contrôle a son propre périmètre.
      - q: Où décider d’une approbation de connecteur ?
        a:
          Ouvre l’exécution d’automatisation en attente. Si elle travaille sur
          une tâche, la carte d’approbation y apparaît aussi. Ces approbations
          sont distinctes de la revue du résultat d’un agent.
      - q: Puis-je choisir les écritures de connecteur à approuver ?
        a:
          Oui. Tu peux configurer la politique pour un connecteur ou une
          action précise. Les écritures externes nécessitent une approbation
          par défaut. Modifier la politique ne résout pas une demande déjà en
          attente.
      - q: Chaque action d’agent attend-elle une approbation ?
        a:
          Non. Le relais de connecteurs expose les lectures aux agents ; les
          écritures soumises aux règles d’approbation passent par les nœuds
          d’automatisation. Les outils GitHub directs et les secrets accordés
          explicitement ont leurs propres accès. Vérifie aussi ces
          autorisations.
      - q: Comment s’appliquent les filtres et contrôles des données ?
        a: Les filtres du chat peuvent vérifier les entrées et sorties
          configurées. Les points d’accès de l’API de modèles filtrent
          uniquement les entrées. La détection de données personnelles dépend
          des motifs configurés. Évalue ensemble l’hébergement, les
          fournisseurs et les procédures.
  docs:
    - label: Concepts approbation
      path: /platform/approvals/concepts
    - label: Configurer approbations
      path: /platform/approvals/configure
    - label: Approbations dans workflows
      path: /platform/automations/approvals-in-workflows
    - label: Journaux d’audit
      path: /platform/admin/governance/audit-logs
    - label: Guardrails
      path: /platform/admin/governance/guardrails
  tour:
    heading: Retrouve les règles dans le travail
    description: Examine les exécutions, compare les réponses et vérifie les outils et
      sources accessibles aux agents.
    stages:
      - id: automations
        eyebrow: Automatisations
        title: |-
          Suivre l’exécution
          et ses décisions
        description:
          Un processus configuré peut examiner un rapport d’accès et préparer
          une notification. Consulte ses étapes, décisions d’approbation et
          effets enregistrés dans le détail de l’exécution.
      - id: agents
        eyebrow: Agents
        title: |-
          Choisir les outils
          nécessaires au travail
        description:
          Accorde explicitement les outils et identifiants de chaque agent.
          Les appels de modèles gérés utilisent les contrôles de la passerelle
          Tale ; les abonnements directs suivent un autre parcours.
  demos:
    govern:
      label: "Illustration : une automatisation demande une approbation avant qu’un
        connecteur envoie une mise à jour de politique par e-mail, puis
        enregistre la décision et l’exécution."
      approvalTitle: Envoyer la mise à jour de politique à l’équipe du projet ?
      requester: Processus de politique · Connecteur de messagerie
      audit1: Approuvé par lena@nordwind.eu
      audit2: E-mail de mise à jour de politique envoyé
      audit3: 'Entrée d’audit #8841 écrite'
      budgetValue: CHF 220 / 800
    automation:
      label: "Illustration : un processus planifié et configuré examine un rapport
        d’accès et prépare une notification Slack."
      trigger: Chaque jour
      llm: Revue d’accès
      condition: Nouvel admin ?
      branchYes: Oui
      action: 'Alerte #security'
      actionAlt: Archiver
      run1: '#98'
      runTone1: done
      duration1: 3,4 s
      run2: '#99'
      runTone2: done
      duration2: 3,1 s
      run3: '#100'
      runTone3: running
      duration3: 0,6 s
    connect:
      label:
        "Illustration : agents de projet aux responsabilités et modèles
        distincts ; leurs outils et autorisations se configurent séparément."
      agent1: Agent Politique
      model1: Claude Sonnet
      agent2: Agent Audit
      model2: Claude Opus
      agent3: Agent Budget
      model3: GPT-5.5
      agent4: Agent Accès
      model4: Claude Sonnet
      agent5: Agent Exceptions
      model5: Claude Opus
platformHub:
  title: Comment fonctionne la plateforme Tale ?
  description: Tale réunit collègues et agents IA dans un espace de projet. Planifie les
    tâches sur des tableaux, délègue-les aux agents dans leurs sandboxes et
    examine les résultats avec leur contexte et leurs fichiers.
  modulesHeading: Modules plateforme
  modulesDescription: Les projets organisent le travail. Les agents exécutent les tâches
    attribuées. Le chat et les connaissances fournissent le contexte. Les
    automatisations rendent les étapes réutilisables ; la gouvernance définit
    les accès et les validations.
  tour:
    heading: Comment la plateforme s’assemble
    description: Planifie un projet, équipe les agents pour ses tâches et examine leurs
      résultats. Les connaissances, le chat et les workflows réutilisables
      soutiennent le travail de ton équipe.
    stages:
      - id: agents
        eyebrow: Agents
        title: |-
          Des agents pour
          les tâches du projet
        description:
          Configure les agents de projet avec un moteur pris en charge, un
          modèle et des outils. Attribue-leur des tâches et suis leur
          progression avec ton équipe.
      - id: projects
        eyebrow: Projets
        title: Isole par équipe
        description:
          Réunis tâches, agents, fichiers et consignes dans un projet. Définis
          son accès et partage explicitement les chats que ton équipe doit
          pouvoir lire.
  faq:
    heading: FAQ plateforme
    items:
      - q: Qu’est-ce que la plateforme dans Tale ?
        a:
          Tale est un espace de projet open source pour les équipes et les
          agents IA. Planifie les tâches, délègue le travail, suis la
          progression et examine les résultats avec un contexte partagé et des
          workflows réutilisables.
      - q: Quels modules Tale inclut-il ?
        a:
          Chat, Projets, Connaissances, Agents, Automatisations et Gouvernance — les Projets
          isolent le travail, les fichiers et les agents par équipe.
      - q: Tale est-il open source ?
        a: Oui. Community est open source et gratuite en auto-hébergement.
          Enterprise ajoute support et services sur la même base de code.
      - q: Par où commencer ?
        a:
          Commence par un projet et une tâche dont tu peux évaluer le
          résultat. Ajoute les fichiers utiles, attribue un agent configuré,
          lance-le et examine ce qu’il produit.
  demos:
    connect:
      label:
        'Démo animée : l’échantillon Agents du hub — agent Orchestrateur, agent
        Support, agent Docs, agent Facture et agent Politique, chacun avec son
        modèle.'
      agent1: Agent Orchestrateur
      model1: Claude Sonnet
      agent2: Agent Support
      model2: Claude Sonnet
      agent3: Agent Docs
      model3: Claude Opus
      agent4: Agent Facture
      model4: GPT-5.5
      agent5: Agent Politique
      model5: Claude Opus
    projects:
      label:
        'Démo animée : échantillon Projets du hub — Cœur plateforme, Pilotes
        clients, Enablement partenaires et Ops internes, chacun avec son
        roster.'
      project1: Cœur plateforme
      agents1: 6 agents
      members1: '12'
      project2: Pilotes clients
      agents2: 3 agents
      members2: '7'
      project3: Enablement partenaires
      agents3: 2 agents
      members3: '5'
      project4: Ops internes
      agents4: 4 agents
      members4: '9'
platformKnowledge:
  eyebrow: Connaissances
  title: Que sont les connaissances dans Tale ?
  description: Mets documents, faits utiles, contenus web et données structurées à
    disposition de ton équipe. Le chat et les agents de projet équipés pour
    cela peuvent consulter les sources accessibles pour répondre et travailler
    sur les tâches.
  capabilities:
    heading: Que contiennent les connaissances ?
    description:
      Prépare des sources utiles pour la recherche et vérifie les éléments qui
      étayent une réponse ou un livrable.
    items:
      - title: Documents avec pipeline d’indexation
        body:
          Importe des fichiers pris en charge et vérifie leur indexation. Le
          texte indexé peut être consulté avec ses références de source.
        docsLabel: Documents
      - title: Fiches de connaissances
        body:
          Enregistre un fait concis sous un sujet stable. Actualise la fiche
          lorsque l’information change et consulte son historique de versions.
        docsLabel: Fiches de connaissances
      - title: Crawls de sites
        body:
          Indexe les pages que tes agents doivent citer sans les coller dans les
          prompts.
        docsLabel: Crawling
      - title: Enregistrements typés
        body:
          Les contacts et les produits regroupent des champs nommés. Les
          personnes et les agents peuvent consulter des valeurs précises avec
          les documents qui les complètent.
        docsLabel: Données structurées
      - title: L’accès suit les règles de la source
        body:
          Les restrictions d’équipe et l’accès au projet s’appliquent aussi à
          la recherche. Les agents de projet ont besoin des outils
          correspondants pour consulter les connaissances.
        docsLabel: Vue d’ensemble des connaissances
  faq:
    heading: FAQ sur les connaissances
    items:
      - q: Que sont les connaissances dans Tale ?
        a:
          Les connaissances réunissent documents, fiches, sites indexés,
          contacts et produits partagés. Elles donnent une référence commune
          aux questions et aux tâches du projet. Vérifie ensuite les sources
          utilisées.
      - q: Qu’est-ce qui détermine les sources consultables ?
        a:
          La recherche respecte les autorisations des sources et le contexte
          du projet. Les chats de projet peuvent consulter ses fichiers et les
          connaissances accessibles de l’organisation. Les agents doivent
          disposer des outils correspondants.
      - q: Quelle différence entre documents et enregistrements typés ?
        a:
          Les documents et fiches fournissent du texte à rechercher. Les
          contacts et produits stockent des champs nommés pour des
          consultations précises. Vérifie dans les deux cas la source et son
          actualité.
      - q: Comment partager un fait utile dans les connaissances ?
        a:
          "Une personne autorisée à modifier les connaissances peut créer ou
          actualiser une fiche. Les intégrations peuvent aussi le faire via
          l’API. Vérifie le fait avant de l’enregistrer : le chat ne l’ajoute
          pas automatiquement à la bibliothèque."
  docs:
    - label: Vue d’ensemble des connaissances
      path: /platform/knowledge/overview
    - label: Documents
      path: /platform/knowledge/documents
    - label: Fiches de connaissances
      path: /platform/knowledge/knowledge-entries
    - label: Crawling
      path: /platform/knowledge/crawling
    - label: Données structurées
      path: /platform/knowledge/structured-data
  tour:
    heading: Comment le savoir ancre Tale
    description:
      Prépare les sources de l’entreprise, utilise-les pour les questions et
      les tâches du projet, puis examine les références qui étayent le
      résultat.
    stages:
      - id: chat
        eyebrow: Chat
        title: |-
          Consulte les sources
          d’une réponse
        description:
          Les passages récupérés deviennent des cartes de citation — le
          lecteur ouvre le fichier ou la page utilisée.
      - id: projects
        eyebrow: Projets
        title: |-
          Les bibliothèques vivent
          avec leurs équipes
        description:
          Les projets définissent quels documents côtoient quels agents et
          membres.
  demos:
    knowledge:
      label: 'Démo animée : la bibliothèque de l’organisation indexe le manuel
        produit, le crawl du site de docs, la liste de prix 2026 et une entrée
        FAQ d’onboarding.'
      source1: manuel-produit-v4.pdf
      sourceType1: pdf
      source2: docs.nordwind.eu
      sourceType2: website
      source3: Liste de prix 2026
      sourceType3: catalog
      source4: FAQ d’onboarding
      sourceType4: entry
    hero:
      label:
        "Exemple illustré : un chat répond à une question sur un produit à
        partir de passages retrouvés et cite un guide et une fiche de FAQ."
      prompt: Qu’est-ce qui change dans le manuel v4 pour la batterie en hiver ?
      routedTitle: Modèle sélectionné
      routedDetail: Claude Sonnet répond à partir des références produit consultées.
      reply1: La v4 resserre le stockage longue durée à 10–20 °C au-delà de 30 jours.
      reply2: Charge à 60 % avant de remiser — une charge pleine vieillit les cellules.
      reply3: L’avertissement de dégivrage passe dans l’encart de démarrage rapide,
      reply4: et le firmware 3.2 ajoute un verrou de charge à basse température.
      citation1: manuel-produit-v4.pdf
      citation2: FAQ d’onboarding
      composerModel: Claude Sonnet
    projects:
      label:
        'Démo animée : projets qui gardent les bibliothèques à côté des agents et
        membres qui les utilisent.'
      project1: Corpus produit
      agents1: 3 agents
      members1: '7'
      project2: Macros support
      agents2: 2 agents
      members2: '9'
      project3: Rayon politiques
      agents3: 2 agents
      members3: '5'
      project4: Wiki ingénierie
      agents4: 4 agents
      members4: '12'
platformProjects:
  eyebrow: Projets
  title: Que sont les Projets dans Tale ?
  description:
    Réunis ton équipe, ses tâches, ses agents et ses fichiers de référence
    autour d’un objectif commun. Planifie le travail sur le tableau, lance les
    tâches des agents et examine les résultats avec ton équipe.
  capabilities:
    heading: Un espace de travail par sujet
    description:
      Coordonne un lancement, une recherche ou une amélioration interne avec
      un tableau partagé, des instructions de projet et des agents équipés
      pour ce travail.
    items:
      - title: Un contexte qui suit le travail
        body: Regroupe les tâches, les instructions et les fichiers de référence
          dans un projet. Ses chats utilisent les instructions du projet et
          peuvent consulter les fichiers pertinents.
        docsLabel: Vue d’ensemble des projets
      - title: Un tableau d’où les agents travaillent
        body:
          Attribue une tâche à un agent de projet, puis lance-la. Suis sa
          progression et examine le rapport et les fichiers joints lorsque
          l’agent a terminé.
        docsLabel: Automatisation des tâches
      - title: Un backlog pour le travail proposé
        body:
          Rassemble les idées et les tâches proposées par les agents dans le
          backlog. Précise la demande, attribue la tâche et choisis le travail
          à lancer.
        docsLabel: Backlog du projet
      - title: Des fichiers qui restent dans le projet
        body:
          Organise les fichiers de référence dans l’onglet Connaissances du
          projet. Le contenu indexé est accessible dans le contexte de ce
          projet, selon les règles d’accès.
        docsLabel: Gérer les fichiers
      - title: Des agents équipés pour ton projet
        body:
          Crée des agents de projet avec un rôle, un environnement d’exécution
          et un modèle compatibles, des instructions et des outils. Attribue
          le travail à l’agent préparé pour cette tâche.
        docsLabel: Agents de projet
  faq:
    heading: FAQ Projets
    items:
      - q: Qu’est-ce qu’un projet dans Tale ?
        a: Un espace de travail partagé qui réunit chats, fichiers, instructions
          et tâches autour d’un même travail — un contact, un lancement, une
          enquête — pour que le contexte reste avec le travail.
      - q: Comment les agents traitent-ils les tâches d’un projet ?
        a:
          Attribue une tâche, puis lance l’agent ou passe la tâche à En cours.
          L’agent travaille dans son sandbox et remet un rapport et des
          fichiers à examiner. Une personne ou un agent de vérification
          affecté séparément peut examiner le résultat. L’attribution seule ne
          lance aucune exécution.
      - q: Qui voit les chats et fichiers d’un projet ?
        a:
          Les projets sont accessibles à toute l’organisation par défaut. Tu
          peux limiter leur audience à certaines équipes ; les administrateurs
          conservent l’accès. Les chats restent personnels tant qu’ils ne sont
          pas explicitement partagés, y compris dans un projet.
      - q: Quelle différence entre un projet et un chat ?
        a:
          Un chat est une conversation avec un assistant IA. Un projet
          organise le travail dans la durée avec un tableau de tâches, des
          agents, des instructions, des fichiers et des chats. Un nouveau chat
          utilise les instructions du projet, sans importer automatiquement
          les conversations précédentes.
  docs:
    - label: Vue d’ensemble des projets
      path: /platform/projects/overview
    - label: Concepts des projets
      path: /platform/projects/concepts
    - label: Automatisation des tâches
      path: /platform/projects/task-automation
    - label: Backlog du projet
      path: /platform/projects/backlog
    - label: Gérer les fichiers
      path: /platform/projects/manage-files
    - label: Agents de projet
      path: /platform/projects/project-agents
  tour:
    heading: Comment un projet fait avancer le travail
    description:
      Planifie le travail avec ton équipe, délègue des tâches aux agents et
      examine leurs rapports. Appuie le travail sur les instructions et les
      fichiers de référence du projet.
    stages:
      - id: tasks
        eyebrow: Tâches
        title: |-
          Attribue une tâche,
          puis lance l’agent
        description:
          Décris clairement la tâche et attribue-la à un agent de projet.
          Lance le travail, suis sa progression et examine le rapport et les
          fichiers remis pour vérification.
      - id: chat
        eyebrow: Chats
        title: |-
          Donne aux chats du projet
          des consignes communes
        description:
          Les instructions du projet s’appliquent à ses chats, et l’assistant
          peut consulter les fichiers pertinents. Ajoute les décisions
          précédentes dont une nouvelle conversation a besoin.
  demos:
    hero:
      label:
        "Exemple illustré : un chat de projet utilise les instructions et les
        fichiers de référence consultés pour répondre à une question sur la
        refonte d’un site."
      prompt: Que reste-t-il avant la mise en ligne de la refonte ?
      routedTitle: Modèle sélectionné
      routedDetail: L’assistant de chat utilise les instructions du projet et consulte les
        fichiers pertinents.
      reply1:
        La checklist de lancement mentionne encore la vérification des
        redirections et les textes de la page de tarifs.
      reply2:
        Elle prévoit un test en préproduction lorsque ces deux points seront
        prêts.
      reply3: La bascule DNS est calée avec l’IT jeudi à 06h00,
      reply4: et la checklist signale la redirection /docs non testée comme un
        risque à traiter.
      citation1: checklist-lancement.pdf
      citation2: Plan de redirections
      composerModel: Claude Opus
    govern:
      label:
        "Exemple illustré : un workflow de publication configuré attend
        l’approbation du Connector avant de tenter de publier la nouvelle page
        de tarifs."
      approvalTitle: Publier la nouvelle page tarifs en production ?
      requester: Refonte du site · Workflow de publication
      audit1: Approuvé par mira@nordwind.eu
      audit2: Page tarifs publiée
      audit3: Décision enregistrée dans le journal d’audit
      budgetValue: CHF 120 / 400
    tasks:
      label: "Démo animée : le tableau de refonte du site. L’agent de refonte travaille sur WEB-12 dans En cours, tandis que WEB-11 attend dans En revue."
      id1: WEB-14
      title1: Finir la carte de redirections /docs
      assignee1: Non assigné
      id2: WEB-15
      title2: Réécrire le hero de la page pricing
      assignee2: Mira
      id3: WEB-12
      title3: Rédiger le guide de migration du relaunch
      assignee3: Relaunch Agent
      id4: WEB-11
      title4: Valider la checklist staging
      assignee4: Relaunch Agent
      id5: WEB-9
      title5: Publier le set de tokens de marque
      assignee5: Design Agent
pricingPage:
  relatedHeading: À suivre
  ctaTitle: Mets un chiffre sur ta configuration
  ctaDescription: Demande une démo ou parle à l’équipe des sièges Enterprise, du
    stockage et du matériel.
  faq:
    heading: FAQ tarifs
    items:
      - q: Combien coûte Tale Enterprise ?
        a:
          Tale Enterprise coûte 12 CHF (14 €) par utilisateur et par mois, avec deux
          mois offerts en facturation annuelle. Le stockage coûte 10 CHF (12 €)
          par To et par mois.
      - q: Community est-il gratuit ?
        a: Oui. L’édition Community est gratuite à auto-héberger en open source.
      - q: Puis-je acheter du matériel avec le logiciel ?
        a:
          Oui. Du matériel d’inférence silencieux est disponible en location, leasing
          ou achat — vois les tarifs matériel.
changelogPage:
  eyebrow: Changelog
  title: Quoi de neuf dans Tale ?
  description:
    Les notes de version de Tale, de la plus récente à la plus ancienne
    — publiées depuis GitHub Releases.
  allReleases: Toutes les versions
  sourceNote: 'Source :'
  githubLink: GitHub Releases
  viewOnGithub: Voir sur GitHub
  emptyBody: Pas de notes pour cette version.
  fetchedAt: Dernière mise à jour le {date}.
contentPages:
  comparisons:
    directoryTitle: Trouve ton comparatif
    directoryDescription: Cherche un produit que tu connais ou filtre les guides selon la décision à prendre.
    searchLabel: Rechercher un comparatif
    searchPlaceholder: Nom de produit ou sujet
    filterLabel: Type de comparaison
    resultCount: '{count} sur {total} guides'
    emptyTitle: Aucun comparatif ne correspond
    emptyDescription: Essaie un autre produit ou sujet, ou efface ta recherche et tes filtres pour voir tous les guides.
    reset: Afficher tous les comparatifs
    sameBrief: Un brief, deux approches
    workspace: Espace de projet partagé
    criteriaLabel: Ce que ce guide compare
    types:
      all:
        label: Tous les guides
        description: Compare le fonctionnement dont ton équipe a besoin et les possibilités de combiner différents produits.
      direct:
        label: Plateformes d’équipe
        description: Compare les produits qui coordonnent les personnes et les agents, la délégation des tâches et la revue du travail partagé.
      adjacent:
        label: Assistants & outils
        description: Compare les assistants, les outils de workflows et les créateurs d’applications à un espace de projet partagé.
      framework:
        label: Frameworks
        description: Décide si tu veux adopter un espace de travail ou créer ta propre application d’agents et son interface pour l’équipe.
      runtime:
        label: Environnements d’agent
        description: Distingue un environnement d’agent compatible de l’espace de travail qui l’entoure.
  tableScrollHint: Fais défiler horizontalement pour comparer
  breadcrumb: Chemin de la page
  reviewed: 'Vérifié le {date}'
  relatedTitle: Des tâches à essayer avec ton équipe
  relatedDescription: Commence par un brief clair, des livrables définis et un processus de révision.
  nextTitle: Essaie avec ton propre projet
  nextDescription: Apporte une tâche concrète et les outils que ton équipe utilise déjà.
  allUseCases: Tous les cas d’usage

demo:
  pages:
    home:
      label: "La vue d’une tâche Tale pour relire un brief de lancement et discuter de la prochaine étape."
      caption: "La tâche, son contexte et la prochaine décision au même endroit."
    hub:
      label: "La boîte de réception de Tale pour lire les conversations clients et rédiger une réponse."
      caption: "Les projets, les chats et les conversations clients dans un même espace de travail."
    agents:
      label: "L’onglet Agents d’un projet Tale pour examiner la configuration d’un agent."
      caption: "Chaque agent de projet a son propre environnement d’exécution, son modèle, ses instructions et son équipement."
    chat:
      label: "L’espace de chat de Tale pour rédiger des prompts et lire les réponses de l’IA."
      caption: "Rédige un prompt, suis la réponse et poursuis le travail."
    projects:
      label: "Le tableau des tâches d’un projet Tale affiche les tâches, leur statut et la personne responsable."
      caption: "Garde une vue d’ensemble du projet, du travail proposé à la vérification et à la finalisation."
    automations:
      label: "Une exécution d’automatisation Tale affiche un workflow terminé, les résultats des étapes, sa version et son statut."
      caption: "Examine le workflow et le résultat de chaque étape dans une vraie exécution."
    knowledge:
      label: "La bibliothèque de connaissances de Tale affiche les entrées partagées sur l’onboarding, la marque et le support."
      caption: "Rassemble les contenus d’onboarding, de marque et de support dans une bibliothèque partagée."
    governance:
      label: "Les journaux d’audit de Tale affichent les actions enregistrées et les personnes qui les ont effectuées."
      caption: "Vérifie qui a changé quoi, contrôle l’intégrité des journaux et exporte la piste d’audit."
